import React, { useState } from "react"
import { Form, Input, Button, message, Divider, Flex } from "antd"
import { useUser } from "../../contexts/UserContext"
import { useLocation, useNavigate } from "react-router-dom"

const ResetPasswordConfirm = () => {
    const { resetPasswordConfirm } = useUser()
    const [form] = Form.useForm()
    const [loading, setLoading] = useState(false)
    const location = useLocation()
    const navigate = useNavigate()
    const query = new URLSearchParams(location.search)
    const key = query.get("key")

    const handleSubmit = async (values) => {
        setLoading(true)
        const { newPassword } = values
        const result = await resetPasswordConfirm(key, newPassword)
        setLoading(false)
        if (result.success) {
            message.success("Lösenordet har återställts.")
            form.resetFields()
            navigate("/login")
        } else {
            message.error(result.message || "Misslyckades med att återställa lösenord.")
        }
    }

    return (
        <Flex style={{ flexWrap: "wrap", flexDirection: "column", alignContent: "center" }}>
        <h1>Fyll i ditt nya lösenord</h1>
            <Form
                style={{width: "300px"}}
                form={form}
                onFinish={handleSubmit}
                initialValues={{
                    newPassword: "",
                    confirmNewPassword: ""
                }}
            >
                <Divider />
                <Form.Item name="newPassword" rules={[{ required: true, message: "Ange nytt lösenord" }]}>
                    <Input.Password placeholder="Nytt lösenord" />
                </Form.Item>
                <Form.Item
                    name="confirmNewPassword"
                    dependencies={["newPassword"]}
                    rules={[
                        { required: true, message: "Bekräfta nytt lösenord" },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue("newPassword") === value) {
                                    return Promise.resolve()
                                }
                                return Promise.reject(new Error("De två lösenorden matchar inte!"))
                            }
                        })
                    ]}
                >
                    <Input.Password placeholder="Bekräfta nytt lösenord" />
                </Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>
                    Återställ lösenord
                </Button>
            </Form>
        </Flex>
    )
}

export default ResetPasswordConfirm
